import React, { useEffect } from "react";
import { audience, benefits, pricing } from "../data/landing";
import { trackInitiateCheckout, trackViewContent } from "../utils/tracking";
import { Marquee } from "../components/Marquee";
import { Hero } from "../components/Hero";
import { TomosCarousel } from "../components/TomosCarousel";
import { ComboSummary } from "../components/ComboSummary";
import { FeatureGrid } from "../components/FeatureGrid";
import { Testimonials } from "../components/Testimonials";
import { PaymentMethods } from "../components/PaymentMethods";
import { Faq } from "../components/Faq";
import { FloatingCta } from "../components/FloatingCta";
import { Footer } from "../components/Footer";
export function Landing() {
  useEffect(() => trackViewContent(pricing.price), []);
  const handleCheckout = () => trackInitiateCheckout(pricing.price);
  return <div className="w-full min-h-screen" style={{
    background: "#04100F"
  }} data-id="element-176" data-mp="h6e9f75ovo3v">
      <Marquee data-id="element-177" data-mp="m83gkbpsjhmo" />
      <Hero onCheckout={handleCheckout} data-id="element-178" data-mp="m5hdopduhqas" />
      <main className="w" data-id="element-179" data-mp="2ajvb4mpwccb">
        <TomosCarousel data-id="element-180" data-mp="2atjcmo7c9fd" />
        <ComboSummary data-id="element-181" data-mp="27xk8v0mbepc" />
        <FeatureGrid kicker="BENEFÍCIOS PRINCIPAIS" title="Mais tempo para o paciente, menos tempo planejando" subtitle="Tudo pensado para o dia a dia de quem atende idosos em consultório, domicílio ou instituição." items={benefits} data-id="element-182" data-mp="3tgbj3xd0vcvy" />
        <FeatureGrid kicker="PARA QUEM É" title="Feito para quem cuida do movimento do idoso" subtitle="Se você trabalha com pessoas 60+, esta coleção vira o seu material de referência." items={audience} data-id="element-183" data-mp="3khzs3u88ud2z" />
        <Testimonials data-id="element-184" data-mp="c76dtmrkmrb6" />
        <PaymentMethods data-id="element-185" data-mp="c6deh6uxz432" />
        <Faq data-id="element-186" data-mp="c5vbzshortmp" />
      </main>
      <Footer data-id="element-187" data-mp="79mzynyscgjr" />
      <FloatingCta onCheckout={handleCheckout} data-id="element-188" data-mp="7825eych0xlw" />
    </div>;
}